/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "utils/clone",
  "underscore",
  "backbone"
], function (
  clone,
  _,
  Backbone
) {
  // Synchronizes a favorites collection with a Backbone.Collection
  //
  // *Options:*
  //   * *persistedCollection:* the favorites collection to save to (typically use application.getModel("persistedresources:favorites/default"))
  //   * *connectedCollection:* the Backbone.Collection to synchronize
  //   * *keyPath:* path to the connected model property to use as key property. The *key* property is used as to find the corresponding connected model.
  //   * *namePath:* path to the connected model property to use as name property
  //   * *type:* value for the type property
  function FavoritesAdapter() {
    this.initialize.apply(this, arguments);
  }

  _.extend(FavoritesAdapter.prototype, Backbone.Events, {

    initialize: function (options) {
      this.options = options;
      this.persistedCollection = options.persistedCollection;
      this.connectedCollection = options.connectedCollection;

      this.listenTo(this.persistedCollection, "add", this.addPersisted);
      this.listenTo(this.persistedCollection, "remove", this.removePersisted);
      this.listenTo(this.persistedCollection, "reset", this.resetPersisted);

      this.listenTo(this.connectedCollection, "add", this.addConnected);
      this.listenTo(this.connectedCollection, "remove", this.removeConnected);
    },

    findPersisted: function (connected) {
      var key = connected.get(this.options.keyPath);
      return this.persistedCollection.find(function (persisted) {
        return persisted.get("properties.key") === key;
      });
    },

    findConnected: function (persisted) {
      return this.connectedCollection.get(persisted.get("properties.key"));
    },

    addPersisted: function (persisted) {
      if (persisted.get("properties.type") !== this.options.type) return;
      if (this.findConnected(persisted)) return;
      // TODO: update?
      this.connectedCollection.add(persisted.get("data"));
    },

    removePersisted: function (persisted) {
      var connected = this.findConnected(persisted);
      if (connected) {
        connected.trigger('destroy', connected, connected.collection);
      }
    },

    resetPersisted: function () {
      var that = this;
      this.connectedCollection.reset();
      this.persistedCollection.each(function (persisted) {
        that.addPersisted(persisted);
      });
    },

    addConnected: function (connected) {
      if (this.findPersisted(connected)) return;
      // TODO: update?
      this.persistedCollection.add({
        properties: {
          name: connected.get(this.options.namePath),
          key: connected.get(this.options.keyPath),
          type: this.options.type
        },
        data: clone(connected.attributes)
      });
    },
    
    removeConnected: function (connected) {
      var persisted = this.findPersisted(connected);
      if (persisted) {
        persisted.trigger('destroy', persisted, persisted.collection);
      }
    },

    dispose: function () {
      this.stopListening();
    }

  });

  return FavoritesAdapter;

});
